import React, { useEffect, useState } from "react";
import { Grid, Paper } from "@material-ui/core";
import { HomeWrapper } from "../components/utils/HomeWrapper";
import { PageTitle } from "../components/utils/PageTitle";
import ReactPlayer from "react-player";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardContent";
import CloseIcon from "@mui/icons-material/Close";
import { Button } from "@mui/material";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { pDataProvider } from "../utils/parameters";
import { useDataProvider } from "../api/DataProvider";
import { useCommProvider } from "../api/CommProvider";
import { Tooltip } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { pDataOrigin, pDataTypeVideo } from "../utils/parameters";

import VideocamIcon from '@mui/icons-material/Videocam';
import EmergencyRecordingIcon from '@mui/icons-material/EmergencyRecording';
import MyLocationIcon from '@mui/icons-material/MyLocation';

import { IconButton } from '@mui/material';
import { MoveYourSkeletonDialog } from "../components/moveYourSkeletonDialog/MoveYourSkeletonDialog";
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import { useTranslation } from "react-i18next";


var lodash = require("lodash");

import "../styles/devices/mob_VersusMachine.css";
import "../styles/devices/mob_Hub.css";

const Accordion = styled((props) => <MuiAccordion disableGutters elevation={0} square {...props} />)(({ theme }) => ({
  borderBottomLeftRadius: "10px",
  borderBottomRightRadius: "10px",
}));

const AccordionSummary = styled((props) => <MuiAccordionSummary expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem", color: "white", marginRight: "10px" }} />} {...props} />)(({ theme }) => ({
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  backgroundColor: "white",
  border: "1px solid #5ea0d4",
  borderBottomLeftRadius: "10px",
  borderBottomRightRadius: "10px",
}));

const SCREEN_INIT = 1;
const SCREEN_ACTION = 2;

const SHOW_ORIGINAL = 0
const SHOW_OVERLAY = 1
const SHOW_KEYPOINTS = 2

const TEMPLATE_DATA = {
  gloss_id: "",
  video_user: "",
  counter_repeats_used: 0,
};

export function MoveYourSkeleton() {
  const { t } = useTranslation("global")
  
  const { comm_getPublicURLVideoData } = useDataProvider();

  const [ activeScreen, setActiveScreen] = useState(SCREEN_INIT);
  const { token_id, currentUser, json_data_glosses, json_data_meaning } = useDataProvider();
  const { comm_getDataMoveYourSkeleton, comm_sendResultsMoveYourSkeleton, comm_getVideoData } = useCommProvider();

  const [url_request_vid_original, set_url_vid_original] = useState("");
  const [url_request_vid_keypoints, set_url_vid_keypoints] = useState("");
  const [url_request_vid_overlay, set_url_vid_overlay] = useState("");

  const [user_vid_original, set_user_vid_original] = useState(null);
  const [user_vid_keypoints, set_user_vid_keypoints] = useState(null);
  const [user_vid_overlay, set_user_vid_overlay] = useState(null);

  const [ video_reference, setVideo_reference ] = useState(null)
  const [ video_user, setVideo_user ] = useState(null)

  const [video_request_play, setVideo_request_play] = useState(true);
  const [video_user_play, setVideo_user_play] = useState(false);
  
  const [isCompleted, setIsCompleted] = useState(false);
  const [accordionExpanded, setAccordionExpanded] = useState(false);

  const [ show_video, setShow_video ] = useState(SHOW_ORIGINAL); // 0: Overlay, 1: Keypoints

  const [ openDialog, setOpenDialog ] = useState(false);
  const [ request_gloss_id, setRequest_gloss_id ] = useState('')
  const [ response_video_user, setResponse_video_user ] = useState('')
  const [ counter_repeats_used, setCounter_repeats_used ] = useState(0)

  const [server_report_activity, setServer_report_activity] = useState({});    //  ACTUAL REPORT & PERSONAL MARKS & RANKING INFO
  // const [firstIteration, setFirstIteration] = useState(true);                   //  ACTUAL REPORT & PERSONAL MARKS & RANKING INFO

  const [ score_Kps, setScore_Kps ] = useState(0)
  
  

  // REQUEST DATA.
  async function obtainData() {

    // Coger el primero actualente no contemplamos organizarlo en packs (como Usuario contra máquina) sino de uno en uno.);
    setRequest_gloss_id((await comm_getDataMoveYourSkeleton(token_id, currentUser))[0]["gloss_id"]);
    setCounter_repeats_used(0);
    setShow_video(SHOW_ORIGINAL)

  }

  // useEffect(() => {
  //   console.log("GLOSS_ID", request_gloss_id);
  //   console.log("response_video_user", response_video_user);
  //   console.log("counter_repeats_used", counter_repeats_used);
  // }, [request_gloss_id, counter_repeats_used, response_video_user]);


  async function loadVideos() {
    // console.log ('LOAD VIDEOS')

    // console.log("🚀 ~ file: MoveYourSkeleton.js:118 ~ loadVideos ~ user_vid_overlay:", user_vid_overlay)
    // console.log("🚀 ~ file: MoveYourSkeleton.js:118 ~ loadVideos ~ url_request_vid_overlay:", url_request_vid_overlay)
    // console.log("🚀 ~ file: MoveYourSkeleton.js:118 ~ loadVideos ~ user_vid_keypoints:", user_vid_keypoints)
    // console.log("🚀 ~ file: MoveYourSkeleton.js:118 ~ loadVideos ~ url_request_vid_keypoints:", url_request_vid_keypoints)

    if (show_video === SHOW_ORIGINAL) {
      setVideo_reference(url_request_vid_original);      
      setVideo_user(user_vid_original);
    } 

    if (show_video === SHOW_OVERLAY) {
      setVideo_reference(url_request_vid_overlay);      
      setVideo_user(user_vid_overlay);
    } 
      
    if (show_video === SHOW_KEYPOINTS) {
      setVideo_reference(url_request_vid_keypoints);    
      setVideo_user(user_vid_keypoints);
    }
  }

  // LOADED DATA - LOAD VÍDEOS
  useEffect(() => {
    async function getVideoFromServerUserVideos(video_user) {
      // console.log('GetVideoFromServerUserVideos')
      set_user_vid_original(await comm_getVideoData(token_id, currentUser, pDataOrigin.moveYourSkeleton_LABEL, video_user, pDataTypeVideo.video_RGB));
      set_user_vid_keypoints(await comm_getVideoData(token_id, currentUser, pDataOrigin.moveYourSkeleton_LABEL, video_user, pDataTypeVideo.video_KEYPOINTS));
      set_user_vid_overlay(await comm_getVideoData(token_id, currentUser, pDataOrigin.moveYourSkeleton_LABEL, video_user, pDataTypeVideo.video_OVERLAY));
    }
    if (request_gloss_id !== "") {
      set_url_vid_original(comm_getPublicURLVideoData(pDataProvider.dir_vid_sign, request_gloss_id));
      set_url_vid_keypoints(comm_getPublicURLVideoData(pDataProvider.dir_vid_versusKeypoints, request_gloss_id));
      set_url_vid_overlay(comm_getPublicURLVideoData(pDataProvider.dir_vid_versusOverlay, request_gloss_id));

      if (response_video_user !== "") {
        getVideoFromServerUserVideos(response_video_user);
      }else{
        console.log('Skip getVideoFromServerUserVideos')
      }
    }else {

      set_url_vid_original(null)
      set_url_vid_keypoints(null)
      set_url_vid_overlay(null)

      set_user_vid_original(null)
      set_user_vid_keypoints(null)
      set_user_vid_overlay(null)
    }
  }, [request_gloss_id, response_video_user]);

  function startVideoPlay() {
    // console.log("startVideoPlay");
    setVideo_request_play(true);
    if (response_video_user !== "") {
      setVideo_user_play(true);
    }
  }

  useEffect(() => {
    loadVideos();
    startVideoPlay()
  },[show_video, url_request_vid_keypoints, url_request_vid_overlay, user_vid_keypoints, user_vid_overlay]);


  // RECORDED VIDEO - ENABLING COMPLETED STATE
  useEffect(() => {
    if (response_video_user !== '') {
      setIsCompleted(true);
      btn_Send_Server();
    } else {
      setIsCompleted(false);
    }
  }, [response_video_user]);

  
  const clickBtnRepeat = (event) => {
    setShow_video(SHOW_ORIGINAL)
    startVideoPlay()
  };

  const endVideoRequest = (event) => {

    if (show_video === SHOW_KEYPOINTS) {
      setVideo_request_play(false);
    } else{
      handleSwitchTypeData()
    }
    
  };

  const endVideoUser = (event) => {
    setVideo_user_play(false);
  };


  // CHANGE OF STATES : INIT & ACTION
  const initStateAction = () => {
    setRequest_gloss_id("");
    setResponse_video_user("");
    setCounter_repeats_used(0);

    setActiveScreen(SCREEN_ACTION);
    obtainData();
  };

  const returnMenuMoveYourSkeleton = () => {
    // console.log("returnMenuMoveYourSkeleton");
    setActiveScreen(SCREEN_INIT);
    // setFirstIteration(false);

    setRequest_gloss_id("");
    setResponse_video_user("");
    setCounter_repeats_used(0);
  };

  const returnRecorderMoveYourSkeleton = () => {
    setShow_video(SHOW_ORIGINAL)
  }
  
  const returnNextMoveYourSkeleton = () => {
    setShow_video(SHOW_ORIGINAL)
    initStateAction()
  };
  
  async function btn_Send_Server() {

    const data = {
      'gloss_id': request_gloss_id,
      'video_sign_id': response_video_user,
      'counter_repeats_used': counter_repeats_used,
      'score_kps': score_Kps,
    }

    const response = {

    }

    setServer_report_activity(await comm_sendResultsMoveYourSkeleton(token_id, currentUser, data));
    setOpenDialog(true)
  }


  // useEffect(() => {
  //   console.log("🚀 ~ file: MoveYourSkeleton.js:306 ~ MoveYourSkeleton ~ server_report_activity:", server_report_activity)
  // }, [server_report_activity]);


  async function btn_Send_Server_Only_Ranking() {
    setServer_report_activity(await comm_sendResultsMoveYourSkeleton(token_id, currentUser, {}));
    setOpenDialog(true);

  }

  const handleAccordionChange = () => {
    setAccordionExpanded(!accordionExpanded);
  };

  useEffect(() => {
    if (video_request_play) {
      setCounter_repeats_used(counter_repeats_used + 1);
    }
  }, [video_request_play, show_video]);

  // rec5QOYzUdmjFxueT  	-- 	Vacuna
  // recbMDN49WedXE0in	--	n.vacuna
  // recIrdWABxRp28ToN	--	VACUNA

  const history = useHistory();
  const handleRecorderScreen = () => {

    const meaning = json_data_glosses[request_gloss_id][pDataProvider.arr_meanings][0] !== undefined ? json_data_glosses[request_gloss_id][pDataProvider.arr_meanings][0] : json_data_glosses[request_gloss_id][pDataProvider.arr_variants][0]
    const lemma = json_data_meaning[meaning][pDataProvider.arr_lemmas][0]

    history.push({
      pathname: "/recorder",
      src: "/moveYourSkeleton",
      lemma: lemma,
      meaning: meaning,
      gloss: request_gloss_id,
      counter_repeats_used: counter_repeats_used,
    });
  };

  const location = useLocation();
  useEffect(() => {
    // console.log("location", location);
    if (location.gloss !== undefined && location.gloss !== "") {
      setRequest_gloss_id(location.gloss);
      setResponse_video_user(location.video_user);
      setCounter_repeats_used(location.counter_repeats_used);
      setScore_Kps(location.score_user);
      setActiveScreen(SCREEN_ACTION);
    }
  }, [location]);

  function handleSwitchTypeData() {
    if (show_video === SHOW_ORIGINAL) {
      setShow_video(SHOW_OVERLAY);
    } 
    if (show_video === SHOW_OVERLAY) {
      setShow_video(SHOW_KEYPOINTS);
    } 
    if (show_video === SHOW_KEYPOINTS) {
      setShow_video(SHOW_ORIGINAL);
    }
  }

  const handleClickOpenURL = (url) => () => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const btn_Open_Report = () => {
    history.push({
      pathname: "/reports",
      src: "/moveYourSkeleton"
    });
  };

  return (
    <HomeWrapper>
      <MoveYourSkeletonDialog openDialog={openDialog} setOpenDialog={setOpenDialog} server_report_activity={server_report_activity} user_vid_original={user_vid_original} user_vid_keypoints={user_vid_keypoints} user_vid_overlay={user_vid_overlay} returnMenuMoveYourSkeleton={returnMenuMoveYourSkeleton} returnRecorderMoveYourSkeleton={returnRecorderMoveYourSkeleton} returnNextMoveYourSkeleton={returnNextMoveYourSkeleton}/>
     <PageTitle title={t("sMoveYourSkeleton.title").toUpperCase()} />

      {activeScreen === SCREEN_INIT ? (
        <div className="sig_VersusMachine_Start_Screen" style={{ display: "flex", flexWrap: "wrap" }}>
          <Card className="sig_VersusMachine_CardContainer">
            <div className="sig_VersusMachine_CardActionArea">

              <Paper className="sig_VersusMachine_PaperContent">
                <div className="sig_Hub_InfoTitle sig_VersusMachine_Start_Title"> {t("sMoveYourSkeleton.btnStartQuestion")} </div>
                {/* <div className="sig_Hub_InfoTitle sig_VersusMachine_Start_Title"> {firstIteration ? '¿ Comenzamos ?':'¿ Continuamos ?'}</div> */}
                <Button className="sig_Hub_ButtonBig sig_Hub_Card_ButtonModal sig_VersusMachine_Fix" onClick={initStateAction}>
                  {" "}
                  {t("sVersusMachine.btnStart").toUpperCase()}
                  {" "}
                </Button>
                <Button className="sig_Hub_ButtonBig sig_Hub_Card_ButtonModal sig_VersusMachine_Fix" onClick={btn_Send_Server_Only_Ranking}>
                  {" "}
                  <EmojiEventsIcon className="sig_VersusMachine_Start_Icon" fontSize="large" /> {t("sVersusMachine.btnShowClasification").toUpperCase()}{" "}
                </Button>
              </Paper>
            </div>
          </Card>
        </div>
      ) : (
        <Grid className="sig_DataSet_Root" container>
          <Card className="sig_DataSet_CardContainer">
            <CardActionArea className={`sig_DataSet_CardActionArea sig_DataSet_ExpandedArea sig_VersusMachine_DataSetFix`}>
              <Grid className="sig_DataSet_ActionAreaContainer sig_VersusMachine_DataSetFix" container>

                <Grid item>

                  <Button className="sig_VersusMachine_Cancel_Button sig_VersusMachine_Left_Button" onClick={returnMenuMoveYourSkeleton}>
                    {" "}
                    <CloseIcon fontSize="inherit" /> <span> {t("strButton.btn_exit").toUpperCase()} </span>{" "}
                  </Button>

                    <Button className="sig_VersusMachine_Cancel_Button sig_VersusMachine_Right_Button" onClick={handleSwitchTypeData}>
                      {" "}
                      {(show_video === SHOW_ORIGINAL) ? 
                        <>
                          <VideocamIcon fontSize="inherit" />
                          <span> {t("sMoveYourSkeleton.typeOriginal").toUpperCase()} </span>{" "}
                        </> :
                        <></>
                      } 
                      {(show_video === SHOW_OVERLAY) ? 
                        <>
                          <EmergencyRecordingIcon fontSize="inherit" />
                          <span> {t("sMoveYourSkeleton.typeOverlay").toUpperCase()} </span>{" "}
                        </> :
                        <></>
                      } 
                      {(show_video === SHOW_KEYPOINTS) ? 
                        <>
                          <MyLocationIcon fontSize="inherit" />
                          <span> {t("sMoveYourSkeleton.typeKeypoints").toUpperCase()} </span>{" "}
                        </> :
                        <></>
                      } 
                    </Button>

                  {<ReactPlayer width="480px" height="480px" className="sig_VersusMachine_ReactPlayer" url={video_reference} onEnded={endVideoRequest} controls={false} playing={video_request_play} loop={false} />}
                </Grid>
                

                <Grid className="sig_DataSet_ActionArea" item>
                  <Grid className="sig_VersusMachine_ActionAreaColumn" container>

                  <Card style={{backgroundColor: "white", padding: '10px', border: '1px solid #5ea0d4'}} className="sig_DataSet_CardContainer">
                    {show_video === SHOW_ORIGINAL ? 'VÍDEO ORIGINAL' : ""}
                    {show_video === SHOW_OVERLAY ? 'VÍDEO CON OVERLAY' : ""}
                    {show_video === SHOW_KEYPOINTS ? 'SÓLO ESQUELETO' : ""}
                    <hr></hr>


                    <div >
                               {show_video === SHOW_ORIGINAL ? 
                                <>
                                  <IconButton className="sig_VersusMachine_Arrow_Button sig_VSResults_Button" onClick={() => setShow_video(SHOW_ORIGINAL)} disabled={show_video === SHOW_ORIGINAL} > 
                                    <VideocamIcon fontSize="medium" color={(show_video == SHOW_ORIGINAL) ? 'disabled' : 'primary'}/> 
                                  </IconButton>
                                </> 
                                : 
                                <>
                                  <Tooltip title={t("sTooltip.show_original")} placement="bottom" arrow>
                                    <IconButton className="sig_VersusMachine_Arrow_Button sig_VSResults_Button" onClick={() => setShow_video(SHOW_ORIGINAL)} disabled={show_video === SHOW_ORIGINAL} > 
                                      <VideocamIcon fontSize="large" color={(show_video == SHOW_ORIGINAL) ? 'disabled' : 'primary'}/> 
                                    </IconButton>
                                  </Tooltip>
                                </>
                                } 
                              {show_video === SHOW_OVERLAY ? 
                                <>
                                  <IconButton className="sig_VersusMachine_Arrow_Button sig_VSResults_Button" onClick={() => setShow_video(SHOW_OVERLAY)} disabled={show_video === SHOW_OVERLAY} > 
                                    <EmergencyRecordingIcon fontSize="medium" color={(show_video == SHOW_OVERLAY) ? 'disabled' : 'primary'}/> 
                                  </IconButton>
                                </> 
                                : 
                                <>
                                  <Tooltip title={t("sTooltip.show_overlay")} placement="bottom" arrow>
                                    <IconButton className="sig_VersusMachine_Arrow_Button sig_VSResults_Button" onClick={() => setShow_video(SHOW_OVERLAY)} disabled={show_video === SHOW_OVERLAY} > 
                                      <EmergencyRecordingIcon fontSize="large" color={(show_video == SHOW_OVERLAY) ? 'disabled' : 'primary'}/> 
                                    </IconButton>
                                  </Tooltip>
                                </>
                                } 


                                {show_video === SHOW_KEYPOINTS ? 
                                <>
                                  <IconButton className="sig_VersusMachine_Arrow_Button sig_VSResults_Button" onClick={() => setShow_video(SHOW_KEYPOINTS)} disabled={show_video === SHOW_KEYPOINTS}> 
                                    <MyLocationIcon fontSize="medium" color={(show_video == SHOW_KEYPOINTS) ? 'disabled' : 'primary'}/> 
                                  </IconButton>
                                </> 
                                : 
                                <>
                                  <Tooltip title={t("sTooltip.show_keypoints")} placement="bottom" arrow>
                                    <IconButton className="sig_VersusMachine_Arrow_Button sig_VSResults_Button" onClick={() => setShow_video(SHOW_KEYPOINTS)} disabled={show_video === SHOW_KEYPOINTS}> 
                                      <MyLocationIcon fontSize="large" color={(show_video == SHOW_KEYPOINTS) ? 'disabled' : 'primary'}/> 
                                    </IconButton>
                                  </Tooltip>
                                </>
                                } 
                        </div>

                        </Card>
                    <Grid className="sig_DataSet_ButtonContainer sig_DataSet_ButtonRepeatContainer" item>
                      <Button className="sig_DataSet_ButtonRepeat sig_VersusMachine_DataSetFix" color="primary" variant="contained" disabled={video_user_play || video_request_play} onClick={clickBtnRepeat}>
                        {t("sRecordComponent.repeatButton").toUpperCase()}
                      </Button>
                    </Grid>


                      <Grid className="sig_DataSet_ButtonContainer sig_VersusMachine_DatasetFix" item>
                        <Button className="sig_DataSet_ButtonConfirm" variant="outlined" color="success" onClick={handleRecorderScreen}>
                          {isCompleted ? "Volver a grabar vídeo" : "Grabar vídeo"}
                        </Button>
                      </Grid>

                      <Tooltip 
                        classes={{arrow: "sig_CustomTooltip_Arrow", tooltip: "sig_CustomTooltip_Container"}}
                        placement="top"
                        arrow
                        title={
                          <div className="sig_CustomTooltip_Content">
                            <span> {t("sMoveYourSkeleton.info_obtain_more_points")} </span>
                          </div>
                        }>
                        <Grid className="sig_DataSet_ButtonContainer sig_DataSet_ButtonConfirmContainer sig_VersusMachine_DatasetFix" item>
                          <Button className="sig_DataSet_ButtonConfirm" variant="outlined" color="success" onClick={handleClickOpenURL('https://efficient-check-bb3.notion.site/C-MO-PUEDO-MEJORAR-MIS-GRABACIONES-708e39d6764b4779a0263254cb400a8a')}>
                            <TipsAndUpdatesIcon/>  <span style={{marginLeft: '20px'}}> {t("sMoveYourSkeleton.question_improve_records")} </span>
                          </Button>
                        </Grid>
                      </Tooltip> 

                  </Grid>
                </Grid>
              </Grid>
            </CardActionArea>
          </Card>
        </Grid>
      )}
    </HomeWrapper>
  );
}
